import { useEffect } from "react";

/** Locks page scroll while a modal is open, so the background scrollbar doesn't sit alongside it. */
export function useLockBodyScroll(locked: boolean) {
  useEffect(() => {
    if (!locked) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previousOverflow; };
  }, [locked]);
}
